module.exports = __webpack_public_path__ + "141d4a85/img/share-icon.0f8a11b4.svg";